// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"af8f9f8f","21":"cfd627c3","283":"2ed999c3","285":"429aa22f","453":"f488a80e","768":"355dacdf","865":"0e1b30c1"}[chunkId] + ".chunk.js";
};